import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExpiredPermissionState } from './expired-permission-state';
import { ExpiredPermissionUiService } from './expired-permission-ui.service';
import { AppConfig } from '@app/config/app.config';

@Component({
    selector: 'app-expired-permission-ui',
    templateUrl: './expired-permission-ui.component.html',
})

export class ExpiredPermissionUiComponent implements OnInit, OnDestroy {
    show = false;

    private subscription: Subscription;

    constructor(
        private expiredPermissionService: ExpiredPermissionUiService,
    ) { }

    ngOnInit() {
        this.subscription = this.expiredPermissionService.expiredPermissionState
            .subscribe((state: ExpiredPermissionState) => {
                const isNewExperience = localStorage.getItem('isNewExperience') == 'true';
                if(isNewExperience){
                    window.top.postMessage("tokenExpired", "*");
                    return;
                }
                this.show = state.show;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public close() {
        localStorage.clear();
        location.href = AppConfig.settings.env.urlLogin;
        this.expiredPermissionService.hide();
    }
}